import Index from './index.vue'
// import Create from './components/Create.vue'
import List from '@/modules/ReportCard/Year/components/List.vue'
import Calendar from '@/modules/ReportCard/Year/components/Calendar.vue'
// import Edit from './components/Edit.vue'

export default [
  {
    path: 'year',
    name: 'year',
    component: Index,
    title: 'year',
    redirect: { name: 'year-list' },
    children: [
      {
        path: 'list',
        name: 'year-list',
        component: List,
      },
      {
        path: ':yearId/calendar',
        name: 'year-calendar',
        component: Calendar,
      },
      
    ],
  },
]
